import React from 'react';
import { Button } from '../../../../GlobalComponents/Button';
import { Flex } from '../../../../GlobalComponents/Flex';
import { Modal } from '../../../../GlobalComponents/Modal';
import { ModalTitle } from './Card';

interface IConfirmationModalProps {
	isOpen: boolean;
	toggleHandler: () => void;
	title: string;
	message: string;
	confirmButtonText?: string;
	cancelButtonText?: string;
	showCancelButton?: boolean;
	confirmHandler: () => void;
	cancelHandler?: () => void;
}

const ApproveTransactionModal = ({
	isOpen,
	toggleHandler,
	title,
	message,
	confirmButtonText = 'Confirm',
	cancelButtonText = 'Cancel',
	showCancelButton = true,
	confirmHandler,
	cancelHandler
}: IConfirmationModalProps): JSX.Element => {
	const confirmButtonRef = React.useRef<HTMLButtonElement>(null);

	const onConfirmPayment = () => {
		toggleHandler();
		if (confirmButtonRef?.current) {
			confirmButtonRef.current.disabled = true;
			confirmHandler();
		}
	};

	return (
		<Modal isOpen={isOpen} toggleHandler={toggleHandler}>
			<ModalTitle>{title}</ModalTitle>
			<span
				style={{
					fontWeight: 'bold',
					color: '#575757',
					lineHeight: '130%'
				}}
			>
				{message}
			</span>
			<Flex
				$flexDirection="row"
				$columnGap="20px"
				$padding="24px 0"
				$placeContent="center flex-end"
			>
				{showCancelButton && (
					<Button
						type="button"
						$buttonSize={'small'}
						$backgroundColor="#757575"
						onClick={cancelHandler}
					>
						{cancelButtonText}
					</Button>
				)}
				<Button
					type="button"
					$buttonSize={'small'}
					$backgroundColor="#F47920"
					onClick={() => onConfirmPayment()}
					ref={confirmButtonRef}
				>
					{confirmButtonText}
				</Button>
			</Flex>
		</Modal>
	);
};

export default ApproveTransactionModal;
